import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classcat from "classcat";
import { toggleEmployees } from "../toggle-employees";
import { displayActiveEmployees } from "../displays/display-active-employees";

import { displayDeleteEmployeesModal } from "../displays/display-delete-employee-modal";
import { selectEmployee } from "../select-employees";
import { translate as t } from "../../../infrastructure/translate/localization";
import RowOfEmployeeTable from "./RowOfEmployeeTable";

export default function ActiveEmployeeTable({
  employees,
  currentPage,
  currentFilters,
  selected,
}) {
  return (
    <table className="employee-table">
      <thead>
        <tr>
          <th className="row-select" aria-label="empty-header" />
          <th>{t("common-messages.internal-id")}</th>
          <th>{t("common-messages.employee")}</th>
          <th>{t("common-messages.benefit-model")}</th>
          <th>{t("common-messages.state")}</th>
          <th className="center-content">{t("actions.enable")}</th>
          <th colSpan="2" aria-label="empty-header" />
        </tr>
      </thead>
      <tbody>
        {employees.map((e) => {
          const isSelected = selected.includes(e.id);
          return (
            <tr
              key={e.id}
              className={`container ${isSelected ? "active" : ""}`}
            >
              <RowOfEmployeeTable
                employee={e}
                isBlocked={e.state === "blocked" || e.state === "removed"}
                selectedItem={() =>
                  selectEmployee({
                    id: e.id,
                    cb: () =>
                      displayActiveEmployees({
                        currentPage,
                        employeeFilter: currentFilters,
                      }),
                  })
                }
                isSelected={isSelected}
                toggleState={(activate) =>
                  toggleEmployees({
                    employeeIds: [e.id],
                    activate,
                    currentPage,
                  })
                }
                deleteItem={() =>
                  displayDeleteEmployeesModal(e.id, currentPage)
                }
              />
              {(e.error || e.warning) && (
                <tr
                  className={classcat([
                    "message",
                    { warning: e.warning, error: e.error },
                  ])}
                >
                  <td colSpan="6">
                    <FontAwesomeIcon icon="check" />
                    {/* <span>Text error message</span> */}
                  </td>
                </tr>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

ActiveEmployeeTable.defaultProps = {};

ActiveEmployeeTable.propTypes = {
  employees: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  currentFilters: PropTypes.func.isRequired,
  selected: PropTypes.array.isRequired,
};
